import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

import { CuttingMatBaseGroup } from '../../models/cutting/cutting-material-group.model';
import { MatBaseGroupDiscount } from '../../models/cutting/mat-base-group-discount.model';

@Component({
  selector: 'csl-group-material-discount-tree-dialog',
  templateUrl: './group-material-discount-tree-dialog.component.html',
  styleUrls: ['./group-material-discount-tree-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class GroupMaterialDiscountTreeDialogComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() discounts: MatBaseGroupDiscount[] = [];
  @Input() groups: CuttingMatBaseGroup[] = [];
  @Input() readonly = false;
  @Input() title = '';

  constructor(public dialogRef: MatDialogRef<GroupMaterialDiscountTreeDialogComponent>, public dialog: MatDialog) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {}

  saveAndClose(): void {}

  discountsChanged(discounts: MatBaseGroupDiscount[] | undefined): void {
    this.discounts = discounts;
  }

  ngOnDestroy(): void {}
}
